import { render, staticRenderFns } from "./ProductSku.vue?vue&type=template&id=e22c9e08&scoped=true&"
import script from "./ProductSku.vue?vue&type=script&lang=js&"
export * from "./ProductSku.vue?vue&type=script&lang=js&"
import style0 from "./ProductSku.vue?vue&type=style&index=0&id=e22c9e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22c9e08",
  null
  
)

export default component.exports